import {useQuery} from '@tanstack/react-query';
import {lkApi} from 'api';

type Params = {
    disabled?: boolean;
};
export function useCurrentUser({disabled}: Params = {}) {
    const {data: currentUserData, isLoading} = useQuery({
        queryKey: ['currentUser'],
        queryFn: lkApi.getCurrentUser,
        staleTime: Infinity,
        retry: false,
        enabled: !disabled,
    });

    if (disabled) {
        return {
            currentUser: null,
            isLoading: false,
        };
    }

    return {
        currentUser: currentUserData,
        isLoading,
    };
}
